//////////////////////////////////
// IMPORTING MODULES
//////////////////////////////////

import React from "react";
import Contact from "../../components/Contact";
import Features from "../../components/Features";
import FAQ from "../../components/FAQ";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Download from "../../components/Download";
import Hero from "../../components/Hero";

//////////////////////////////////
// COMPONENT: LANDING
//////////////////////////////////

const Landing = () => {
  return (
    <div className="min-h-screen bg-[#0e1220] text-gray-100 overflow-x-hidden">
      {/* Navigation */}
      <Navbar />

      {/* Hero Section */}
      <Hero />

      {/* Features Section */}
      <Features />

      {/* FAQ Section */}
      <FAQ />

      {/* Contact Section */}
      <Contact />
      {/* Download Section - Add this before the Contact Section */}
      <Download />

      {/* Footer */}
      <Footer />

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
};

//////////////////////////////////
// EXPORTING LANDING
//////////////////////////////////

export default Landing;
